/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Ad_Import_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to import AD project: {error}" |
*
* @param {Ad_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_import_failed = /** @type {((inputs: Ad_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l'importation du projet AD : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`AD-Projekt konnte nicht importiert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile importare il progetto AD: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось импортировать проект AD: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al importar el proyecto AD: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入 AD 项目失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ADプロジェクトのインポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`AD प्रोजेक्ट आयात करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao importar o projeto AD: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to import AD project: ${i?.error}`)
});